import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import styled from '@emotion/styled'

import {
  BUTTON_VARIANT_PRIMARY,
  Button,
  Flex,
  FlexItem,
  MODAL_SIZE_LG,
  Modal,
  ModalBody,
  TEXT_VARIANT_ITALIC_LIGHT,
  TITLE_VARIANT_MODAL,
  Text,
  Title,
} from 'mailup-web-components'

import IconExtendStatisticsDataPromo from 'Components/icons/IconExtendStatisticsDataPromo'

import { isEcommerceVisible } from 'Helpers/ecommerce'

const StyledDescription = styled.div`
  ul {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 16px;

    padding-left: 24px;

    li {
      list-style-type: disc;
      list-style-position: outside;
    }
  }
`

const StyledPrice = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;

  span:nth-of-type(1) {
    font-weight: 500;
    font-size: 22px;
  }

  span:nth-of-type(2) {
    font-weight: 500;
  }

  span:nth-of-type(3) {
    padding-left: 0.25rem;
    color: #7c7c7c;
  }
`

const StyledContacts = styled(Text)`
  font-size: 14px !important;
`

interface ModalExtendStatisticsDataPromoProps {
  show: boolean
  onCancel: () => void
}

const ModalExtendStatisticsDataPromo: FC<
  ModalExtendStatisticsDataPromoProps
> = ({ show, onCancel }) => {
  const intl = useIntl()

  return (
    <Modal
      show={show}
      size={MODAL_SIZE_LG}
      data-mu-test="modal-data-sync-promo"
      onClose={onCancel}
      closeOnOverlayClick
      showClose
    >
      <ModalBody>
        <Flex gap="30px" margin="20px 0 0 0">
          <FlexItem flex="265px 0 0">
            <IconExtendStatisticsDataPromo />
          </FlexItem>

          <FlexItem flexGrow={1}>
            <Flex flexDirection="column" gap="24px">
              <Title variant={TITLE_VARIANT_MODAL}>
                {intl.formatMessage({
                  id: 'Load.ExtendStatisticsDataPromo.ModalTitle',
                })}
              </Title>

              <StyledDescription>
                {intl.formatMessage(
                  {
                    id: 'Load.ExtendStatisticsDataPromo.ModalBody',
                  },
                  {
                    b: (chunks) => <strong>{chunks}</strong>,
                    linebreak: <br />,
                    ul: (chunks) => <ul>{chunks}</ul>,
                    li: (chunks) => <li>{chunks}</li>,
                  },
                )}
              </StyledDescription>

              <Flex flexDirection="column" gap="4px">
                <Flex alignItems="center" justifyContent="space-between">
                  <StyledPrice>
                    {intl.formatMessage(
                      { id: 'Load.ExtendStatisticsDataPromo.Price' },
                      { span: (chunks) => <span>{chunks}</span> },
                    )}
                  </StyledPrice>
                </Flex>
                <StyledContacts variant={TEXT_VARIANT_ITALIC_LIGHT}>
                  {intl.formatMessage({
                    id: 'Load.ExtendStatisticsDataPromo.ModalContactSales',
                  })}
                </StyledContacts>
              </Flex>
            </Flex>
          </FlexItem>
        </Flex>
      </ModalBody>
    </Modal>
  )
}

export default ModalExtendStatisticsDataPromo
